import React, { useEffect, useState } from 'react';
import { contentsAPI } from '@/utils/contentsApi';
import { cn } from '@/utils/cn';
import { usePathname } from 'next/navigation';
import { useSelector } from 'react-redux';
import { brandCardTypes } from '@/constants/types';
import DynamicSectionTitle from '../Typography/DynamicSectionTitle';
import BrandCardDesktop from '../Card/BrandCardDesktop';

function HomepageBrandCarousel({ section }) {
  const pathName = usePathname();
  const [data, setData] = useState([]);

  const { lang: selectLang } = useSelector((state) => state.globalSettings);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const contentsData = {
          sectionId: section?.id,
          contentType: section?.content_type,
        };
        const response = await contentsAPI(contentsData);

        if (response && Array.isArray(response)) {
          setData([...response]);
        } else {
          setData([]);
        }
      } catch (err) {
        console.warn('Error fetching while get brand data:', err);
      }
    };

    fetchData();
  }, []);

  // will not visible if data is empty
  if (Array.isArray(data) && data?.length === 0) {
    return null;
  }

  return (
    <div className="homepage-top-brand-carousel container 3xl:max-w-[1440px] mx-auto mb-4 lg:mb-[40px]">
      <DynamicSectionTitle
        text={section?.title[selectLang]}
        className={cn({
          'text-center': pathName === '/',
        })}
      />

      <div className="flex items-center justify-center gap-2 lg:gap-5 lg:pt-[20px] pt-[18px] pb-16 lg:pb-0 px-16 lg:px-0">
        {Array.isArray(data) && data?.length > 0
          ? data?.map((brand) => (
              <BrandCardDesktop
                brand={brand}
                key={brand.slug}
                type={brandCardTypes.top}
              />
            ))
          : null}
      </div>
    </div>
  );
}

export default HomepageBrandCarousel;
